module.exports = __webpack_public_path__ + "static/02-c3fb5fc60cec87a47dedc78a08e81b62.png";